/* eslint-disable @typescript-eslint/no-explicit-any */

import { GetterTree, ActionTree, MutationTree } from 'vuex';
import { TransactionStatsState, CurrencyStatistics } from '@/store/interfaces/transactionStats';
import { RootState } from '@/store/interfaces/rootState';
import transactionStatsType from '@/store/types/transactionStats';
import { httpCommpix } from '@/util/HTTPCommpix';
import { AxiosResponse, AxiosError } from 'axios';

const namespaced = true;

const initialState = (): TransactionStatsState => {
  return {
    stats: [],
  };
};

const state: TransactionStatsState = initialState();

const getters: GetterTree<TransactionStatsState, RootState> = {
  [transactionStatsType.getters.GET_TRANSACTION_STATS]: (state) => {
    return state.stats;
  },
};

const mutations: MutationTree<TransactionStatsState> = {
  [transactionStatsType.mutations.SET_TRANSACTION_STATS]: (
    state,
    stats: CurrencyStatistics[]
  ) => {
    state.stats = stats;
  },
};

const actions: ActionTree<TransactionStatsState, RootState> = {
  [transactionStatsType.actions.FETCH_TRANSACTION_STATS]: async (
    { commit, },
    payload?: {
      companyId?: string;
      commerceId?: string;
      branchId?: string;
      date?: string;
    }
  ) => {
    return new Promise((resolve, reject) => {
      httpCommpix
        .post('/dashboard-central/statistics', payload)
        .then((res: AxiosResponse) => {
          commit(transactionStatsType.mutations.SET_TRANSACTION_STATS, res.data);
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
